// KLHS mobile menu (snippets/klhs-menu-drawer.liquid).
// Extends Dawn's MenuDrawer (global.js) so buttons marked [data-drawer-close] close the whole drawer;
// other buttons (the "Menu" back buttons) keep Dawn's close-submenu behaviour.
// Closing always resets aria-expanded so Dawn's header overlay doesn't stay on screen.
if (typeof MenuDrawer !== 'undefined' && !customElements.get('klhs-menu-drawer')) {
  class KlhsMenuDrawer extends MenuDrawer {
    constructor() {
      super();
      // global.js adds its generic onKeyUpEscape to every [id^="Details-"] summary except inside header-drawer /
      // menu-drawer, so it doesn't skip this element. It would close the details before MenuDrawer's own Escape
      // handling runs, leaving the page scroll-locked; MenuDrawer.onKeyUp already handles Escape here.
      if (typeof onKeyUpEscape === 'function') {
        this.querySelectorAll('details').forEach((details) => details.removeEventListener('keyup', onKeyUpEscape));
      }
    }

    onCloseButtonClick(event) {
      if (event.currentTarget.hasAttribute('data-drawer-close')) {
        this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
        return;
      }

      super.onCloseButtonClick(event);
    }

    // Dawn only resets aria-expanded when the menu toggle itself is clicked (or on Escape). Closing from our
    // X buttons would leave it "true", and base.css keeps drawing the dark overlay under the header.
    closeMenuDrawer(event, elementToFocus = false) {
      super.closeMenuDrawer(event, elementToFocus);
      if (event === undefined) return;
      this.mainDetailsToggle.querySelectorAll('summary').forEach((summary) => summary.setAttribute('aria-expanded', false));
    }
  }

  customElements.define('klhs-menu-drawer', KlhsMenuDrawer);
}
